<template>
    <console-content max-width="1920">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">로그</v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>
        
        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-datetime-field v-model="filter.createdAt[0]" label="검색일자" placeholder=" " hide-details clearable></v-datetime-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-datetime-field v-model="filter.createdAt[1]" label="검색일자" placeholder=" " hide-details clearable></v-datetime-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.type" :items="types" label="타입" item-text="text" item-value="value" placeholder=" " hide-details @keydown.enter="page = 1; search(true)" />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.subCode" :items="subCodes" item-text="text" item-value="value" label="상세코드" placeholder=" " hide-details @keydown.enter="page = 1; search(true)" />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" placeholder=" " hide-details @input="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page=1; search(true);">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>
        
        <v-row class="mt-6 px-1" align="end">
            <v-col cols="auto" class="py-0 subtitle-2">검색수 : {{ summary.totalCount.format() }}</v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table :items="logs" :headers="logsHeaders" hide-default-footer disable-pagination disable-sort class="mt-3 mx-1 elevation-1">
            <template slot="item.createdAt" slot-scope="{ item }">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
            <template slot="item.name" slot-scope="{ item }">{{ item.name || workers.find(worker => worker.phone == item.phone)?.name || "-" }}</template>
            <template slot="item.memo" slot-scope="{item}">
                <v-text-field v-model="item.memo" outlined hide-details dense clearable append-icon="save" @click:append="save(item)" />
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>

    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import VDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        VDatetimeField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                createdAt: [this.$route.query.createdAt?.[0] || `${this.$dayjs().format("YYYY-MM-DD")} 00:00:00`, this.$route.query.createdAt?.[1] || `${this.$dayjs().format("YYYY-MM-DD")} 23:59:59`],
                type: this.$route.query.type || "console",
                subCode: this.$route.query.subCode || null,
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            logs: [],
            logsHeaders: [
                { text: "타입", value: "type", align: "center", /* width: 10 */ },
                { text: "코드", value: "code", align: "center", /* width: 10 */ },
                { text: "상세코드", value: "subCode", align: "center", /* width: 10 */ },
                { text: "이름", value: "name", align: "center", /* width: 10 */ },
                { text: "연락처", value: "phone", align: "center", /* width: 10 */ },
                { text: "비고", value: "remark", align: "center", /* width: 10 */ },
                { text: "메모", value: "memo", align: "center", /* width: 10 */ },
                { text: "아이피", value: "ip", align: "center", /* width: 10 */ },
                { text: "날짜", value: "createdAt", align: "center", /* width: 10 */ },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "연락처", value: "phone" },
            ],

            workers: [
                { name: "서순명", phone: "01048773837" },
                { name: "남지영", phone: "01056078657" },
                { name: "조용준", phone: "01051921901" },
                { name: "전채연", phone: "01056240212" },
                { name: "강동훈", phone: "01026071938" },
                { name: "박현수", phone: "01094989473" },
                { name: "우상덕", phone: "01046004701" },
                { name: "박기란", phone: "01056289901" },
                { name: "채선영", phone: "01064797533" },
                { name: "유기찬", phone: "01030990119" },
                { name: "김기준", phone: "01086085724" },
                { name: "이혜정", phone: "01033820100" },
                { name: "송지영", phone: "01089014068" },
                { name: "김철호", phone: "01024602584" },
                // 스마트웰
                { name: "박영선", phone: "01086518192" },
            ],

            types: [
                { text: "Console 로그", value: "console" },
                { text: "API 로그", value: "api" },
            ],

            subCodes: [
                { text: "cp포인트 변경", value: "charge-cp" },
                { text: "핀 폐기", value: "cancel-pin" },
                { text: "핀 수동발행", value: "create-pin" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, logs } = await api.console.common.logs.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.logs = logs;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async save(log){
            if(confirm("메모를 저장하시겠습니까?")){
                await api.console.common.logs.put(log);
            }
        },
        async excel(){
            let { logs } = await api.console.common.logs.gets({ headers: { limit: 0 }, params: this.filter });

            let rows = [];
            logs.forEach(log => {
                rows.push({
                    "타입": log.type,
                    "코드": log.code,
                    "상세코드": log.subCode,
                    "이름": log.name || "-",
                    "연락처": log.phone,
                    "비고": log.remark,
                    "아이피": log.ip,
                    "날짜": this.$dayjs(log.createdAt).format("YYYY-MM-DD HH:mm:ss")
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "로그");
            XLSX.writeFile(workbook, "로그.xlsx");
        }
    }
}
</script>